import { FC, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

import { LoadingSpinner } from '@/components'
import { ConnectedBottomTabNav } from '@/connectors/ConnectedBottomTabNav/ConnectedBottomTabNav'
import { ConnectedNavigation } from '@/connectors/ConnectedNavigation/ConnectedNavigation'
import { ToolTip } from '@/containers'
import { hasStreamAccess } from '@/helpers/streamAccess'
import { useTypedSelector } from '@/redux/store'

import './ConnectedLayout.scss'

export const ConnectedLayout: FC<PropsWithChildren> = ({ children }): ReactElement => {
    const { isEmbedded } = useTypedSelector(state => state.pacoAppReducer)
    const { loading } = useTypedSelector(state => state.appReducer)
    const { currentUser } = useTypedSelector(state => state.userReducer)
    const showBottomTabNav = ! isEmbedded && hasStreamAccess(currentUser)

    return (
        <>
            <ConnectedNavigation />
            {loading && <LoadingSpinner />}
            <div
                className={classNames('layout-content', {
                    'layout-content--with-bottom-nav': showBottomTabNav,
                })}
            >
                {children}
            </div>
            {showBottomTabNav && <ConnectedBottomTabNav />}
            {! isEmbedded && <ToolTip />}
        </>
    )
}
